
/**
 *
 * @export 判断设备类型方法
 * @returns {boolean}
 */
export function checkIsMobile(): boolean {
  const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  const width: number = document.documentElement.clientWidth;
  return !!(flag || width <= 500)
}